import React from 'react'
import CategoryList from '../components/CategoryList'
import BannerProduct from '../components/BannerProduct'
import HorizontalCardProduct from '../components/HorizontalCardProduct'
import { useState, useEffect } from 'react'
import SummaryApi from '../common'

const Home = () => {

  const [allCategories, setAllCategories] = useState([]);

  // Function to fetch all categories
  const fetchAllCategories = async () => {
    try {
      const response = await fetch(SummaryApi.getCategories.url);
      const dataResponse = await response.json();

      console.log("Fetched Categories:", dataResponse);

      setAllCategories(dataResponse?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);


  return (
    <div>
      <CategoryList/>
      <BannerProduct/>
      {allCategories.map((cat)=>(
        <HorizontalCardProduct key={cat._id} category={cat.categoryName} heading={cat.categoryName}/> 
      ))}
       
{/*<HorizontalCardProduct category={"watches"} heading={"Popular's Watches"}/>
      <VerticalCardProduct category={"mobiles"} heading={"Mobiles"}/>
      <VerticalCardProduct category={"Mouse"} heading={"Mouse"}/>
      <VerticalCardProduct category={"televisions"} heading={"Televisions"}/>
      <VerticalCardProduct category={"camera"} heading={"Camera & Photography"}/>
      <VerticalCardProduct category={"earphones"} heading={"Wired Earphones"}/>
      <VerticalCardProduct category={"speakers"} heading={"Bluetooth Speakers"}/>
      <VerticalCardProduct category={"refrigerator"} heading={"Refrigerator"}/>
      <VerticalCardProduct category={"trimmers"} heading={"Trimmers"}/>*/}
    </div>
  )
}

export default Home